import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdvisorModel, AssignAdvisor } from './advisor.model';
import { ApiResponse } from '../../models/base';

const LIST_ENDPOINT = '/advisors';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class AdvisorService {
  employessModel: AdvisorModel = null;

  constructor(private http: HttpClient) {}

  getList(): Promise<AdvisorModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdvisorModel[]>>(environment.apiUrl + LIST_ENDPOINT)
    ).then((response) => response.data);
  }

  addData(advisors: AdvisorModel): Promise<AdvisorModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<AdvisorModel>>(environment.apiUrl + LIST_ENDPOINT, advisors)
    ).then((response) => response.data);
  }

  editData(uid: string, advisors: AdvisorModel): Promise<AdvisorModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<AdvisorModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`, advisors)
    ).then((response) => response.data);
  }

  loadData(uid: number): Promise<AdvisorModel> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdvisorModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.data);
  }

  deleteData(uid: number): Promise<string> {
    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.message);
  }

  assignAdvisor(request: AssignAdvisor): Promise<AdvisorModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<AdvisorModel>>(environment.apiUrl + LIST_ENDPOINT + '/assign', request)
    ).then((response) => response.data);
  }
}